// extracted by mini-css-extract-plugin
export var promotionLink = "_w7-0";